export default {
  backgroundColor: "#444",
};
